import { getPlanFormattedDateFromDate } from '@/core/utils/getPlanFormattedDateFromDate.ts'
import {
  ForecastItem,
  PlanItem,
  PlannedItem,
  Product,
  ShipmentItem,
  SubmittedItem,
} from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'

function getPlannedShippedForecastForMonth(
  product: Product,
  date: Date,
  {
    planned,
    shipments,
    forecast,
    submitted,
  }: {
    planned: PlanItem<PlannedItem>
    shipments: PlanItem<ShipmentItem[]>
    forecast: PlanItem<ForecastItem>
    submitted?: PlanItem<SubmittedItem>
  },
) {
  const productId = product.id
  const planFormattedDate = getPlanFormattedDateFromDate(date)

  const plannedAmount = planned[productId]?.[planFormattedDate]?.amount
  const plannedCost =
    plannedAmount != null ? plannedAmount * product.price : null

  const shippedAmount = shipments[productId]?.[planFormattedDate]?.reduce(
    (acc, item) => acc + item.amount,
    0,
  )
  const shippedCost = shipments[productId]?.[planFormattedDate]?.reduce(
    (acc, item) => acc + item.amount * item.price,
    0,
  )

  let submittedAmount = null
  let submittedCost = null

  if (
    submitted &&
    submitted[productId] &&
    submitted[productId][planFormattedDate]
  ) {
    submittedAmount = submitted[productId][planFormattedDate].amount
    submittedCost = submittedAmount * product.price
  }

  const forecastItemForMonth = forecast[productId]?.[planFormattedDate]

  return {
    plannedAmount,
    plannedCost,
    shippedAmount,
    shippedCost,
    submittedAmount,
    submittedCost,
    forecast: forecastItemForMonth,
  }
}

export { getPlannedShippedForecastForMonth }
